<template>
  <PButton
    class="p-button-rounded small-btn"
    :id="id"
    :class="[className, isLoading ? 'button-loading' : '']"
    :disabled="isLoading"
    @click="$emit('click')"
    :type="type"
  >
    <LoadingSpinner v-if="isLoading" class="mr-3 p-button-loader" />
    <v-mdi
      v-if="icon"
      :name="icon"
      :size="iconSize"
      class="hover:cursor-pointer"
      :class="{ 'mr-2': !!label }"
    ></v-mdi>
    <span
      v-if="label"
      class="p-button-label"
    >
      {{ label }}
    </span>
  </PButton>
</template>

<script>
import LoadingSpinner from "./Extra/LoadingSpinner"

export default {
  name: "Button",
  components: {
    LoadingSpinner,
  },
  props: {
    icon: String,
    iconSize: {
      type: Number,
      default: 24,
    },
    label: String,
    type: {
      type: String,
      default: "button"
    },
    className: {
      type: String,
      default: ""
    },
    id: String,
    isLoading: {
      type: Boolean,
      default: false
    }
  }
}
</script>
